import { render } from "./index.vue?vue&type=template&id=f1087e3c&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=f1087e3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1087e3c"]])

export default __exports__